module.exports = __webpack_public_path__ + "static/media/icon_user.488454f5.svg";